export const QA_NAME_CLOSE_BTN = 'Close'

export const QA_NAME_SAVE_BTN = 'Save'

export const QA_NAME_CLEAR_BTN = 'Clear'

export const QA_NAME_CONFIRM_BTN = 'Confirm'

export const QA_NAME_CREATE_BTN = 'Create'

export const QA_NAME_ATTACH_BTN = 'Attach'

export const QA_NAME_RESET_BTN = 'Reset'

export const QA_NAME_ADD_BTN = 'Add'

export const QA_NAME_APPLY_BTN = 'Apply'

export const QA_NAME_CANCEL_BTN = 'Cancel'

export const QA_NAME_END_BTN = 'End'

export const QA_NAME_NEXT_BTN = 'Next'

export const QA_NAME_EXPORT_BTN = 'Export'

export const QA_NAME_EXTRA_BTN = 'Extra'

export const QA_NAME_OK_BTN = 'Ok'

export const QA_NAME_REMOVE_BTN = 'Remove'

export const QA_NAME_UPLOAD_FILE = 'uploadFile'

export const QA_NAME_SUBMIT_BTN = 'Submit'

export const QA_NAME_DEFAULT = 'qaName'

export const QA_NAME_TEXT_DEFAULT = 'text'

export const QA_NAME_CONFIRMATION = 'confirmation'

export const QA_NAME_REFRESH_BTN = 'refresh'

export const QA_NAME_RESET_SORTING_BTN = 'resetSorting'

export const QA_NAME_EDIT_BTN = 'edit'

export const QA_NAME_BACK_BTN = 'back'

export const QA_NAME_TOGGLE_BTN = 'toggle'

export const QA_NAME_DENSITY_BTN = 'density'

export const QA_NAME_ARROW_BUTTON = 'arrow'

export const QA_NAME_SHOW_MORE_BUTTON = 'showMore'

export const QA_NAME_SHOW_LESS_BUTTON = 'lessBtn'

export const QA_NAME_ICON_DEFAULT = 'Icon'

export const QA_NAME_DENSITY_FULL_CONTENT_BTN = 'densityFullContent'

export const QA_NAME_MODAL_ATTENTION = 'attention'

export const QA_NAME_MODAL_RESIZE_BTN = 'Resize'

export const QA_NAME_MODAL_MINIMIZE_BTN = 'Minimize'

export const QA_NAME_MODAL_OPEN_IN_NEW_WINDOW_BTN = 'OpenInNewWindow'

export const QA_NAME_MINIMIZED_MODAL_RESTORE = 'MinimizedModalRestore'

export const QA_NAME_MINIMIZED_MODAL_CLOSE = 'MinimizedModalClose'

export const QA_NAME_CONFIRMATION_DUPLICATE_OPEN = 'confirmationDuplicateOpen'

export const QA_NAME_CONFIRMATION_MINIMIZED_LEAVE = 'confirmationMinimizedLeave'

export const QA_NAME_CONFIRMATION_MINIMIZED_CLOSE = 'confirmationMinimizedClose'

export const QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED =
  'confirmationMinimizedReplaceDraftSaved'

export const QA_ELEMENT_KEY = 'data-element'

export const QA_PAGE_KEY = 'data-page'

export const QA_MODAL_KEY = 'data-modal'

export const QA_SECTION_KEY = 'data-section'

export const QA_NAME_MODAL_DELETE_BTN = 'Delete'

export const QA_CONTEXT_PAGE = 'page'

export const QA_CONTEXT_PROFILE = 'profile'

export const QA_CONTEXT_PROFILE_WIDGET = 'profileWidget'

export const QA_CONTEXT_WIDGET = 'widget'

export const QA_NAME_DELETE_ITEM = 'deleteItem'

export const QA_NAME_PROFILE_INFO_SECTION = 'infoBody'

export const QA_NAME_PROFILE_INFO_ITEM = 'infoItem'

export const QA_NAME_PROFILE_INFO_ITEM_TITLE = 'infoItemTitle'

export const QA_NAME_PROFILE_INFO_ITEM_VALUE = 'infoItemValue'

export const QA_NAME_PROFILE_TABS_SECTION = 'profileTabs'

export const QA_NAME_SIDE_SECTION = 'sideSection'

export const QA_NAME_PROFILE_ACTIONS_SECTION = 'profileActions'
